module.exports = __webpack_public_path__ + "img/infrared-light-buckboost.0ea36a7d.jpg";